import React from "react";
import { ScreenInterface, ApiHelper, ToastHelper } from "../../helpers";
import { Row, Col, FormControl, FormGroup, FormLabel } from "react-bootstrap"
import { InputBox } from "../../components"

interface Props {
  screen: ScreenInterface,
}

export const PairScreen: React.FC<Props> = props => {

  const [code, setCode] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);


  const handleChange = (e: any) => {
    setCode(e.currentTarget.value)
  }

  const validate = () => {
    if (code.length !== 4) {
      ToastHelper.error("Code should be 4 digits long");
      return false;
    }
    return true;
  }

  const handleSave = () => {
    if (validate()) {
      setIsSubmitting(true);
      ApiHelper.post("/devices/pair", { pairingCode: code, screenId: props.screen.id })
        .then((data: any) => {
          setIsSubmitting(false);
          if (data.success) {
            ToastHelper.success("TV paired successfully");
          }
          else {
            ToastHelper.error("Invalid pairing code");
          }
        })
        .catch(err => {
          console.error("Failed to pair device:", err);
          ToastHelper.error("Failed to pair device");
          setIsSubmitting(false);
        });
    }
  }



  return (
    <>
      <InputBox headerIcon="fas fa-tv" headerText="Pair TV" saveFunction={handleSave} saveText="Pair TV" isSubmitting={isSubmitting}  >
        <Row>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel htmlFor="name">Enter code displayed on screen</FormLabel>
              <FormControl name="code" id="code" value={code} onChange={handleChange} />
            </FormGroup>
          </Col>
        </Row>
      </InputBox >
    </>
  );

}